module.exports = __webpack_public_path__ + "static/partnership_img1@2x-d66423c845e9150bc942badf9b6963c6.jpg";